import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  h2 {
    font-size: 2.4rem;
    font-weight: 600;
    color: ${props => props.theme.colors.text};
  }


  @media ${props => props.theme.breaks.down('md')} {
     h2 {
       font-size: 1.8rem;
     }
  }
`

const FormHeader = styled.h3`

`;

const Container = styled.div`

`;

export { Container, Header, FormHeader };
